export class ErrorRendererClasses {

    /**
     * Style applied to
     */
    static root = "ic3ErrorRenderer-root";
    /**
     * Style applied to
     */
    static logo = "ic3ErrorRenderer-logo";
    /**
     * Style applied to
     */
    static logoW = "ic3ErrorRenderer-logoW";
    /**
     * Style applied to
     */
    static info = "ic3ErrorRenderer-info";
    /**
     * Style applied to
     */
    static schemaNotAuth = "ic3ErrorRenderer-schemaNotAuth";
    /**
     * Style applied to
     */
    static message = "ic3ErrorRenderer-message";
    /**
     * Style applied to
     */
    static detailToggle = "ic3ErrorRenderer-detailToggle";
    /**
     * Style applied to
     */
    static widget = "ic3ErrorRenderer-widget";
    /**
     * Style applied to
     */
    static causeMessage = "ic3ErrorRenderer-causeMessage";
    /**
     * Style applied to
     */
    static causeDetailedMessage = "ic3ErrorRenderer-causeDetailedMessage";
    /**
     * Style applied to
     */
    static causeDetailedInfo = "ic3ErrorRenderer-causeDetailedInfo";
    /**
     * Style applied to
     */
    static causeStacktrace = "ic3ErrorRenderer-causeStacktrace";
}

export declare type ErrorRendererClassKey = keyof ErrorRendererClasses;
